import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { CaseStatus, convertUserToContact, } from '@debbie/common/dist/cases';
import { getContactPerson } from '@debbie/common/dist/customers';
import { getFoundations, isDocumentFoundation, } from '@debbie/common/dist/documents';
import { PaymentPlanStatus, getCurrentPaymentPlan, } from '@debbie/common/dist/economy/payment-plans';
import { getNextTask, NextTaskType } from '@debbie/common/dist/workflows';
import { c, h } from '@debbie/cortex/dist';
import { selectCaseUpdates } from '@debbie/cortex/dist/case/selectors';
import { selectRole } from '@debbie/cortex/dist/me/selectors';
import { selectUpdateTypes, selectUpdateTypesMap, } from '@debbie/cortex/dist/update-types/selectors';
import { selectWorkflows } from '@debbie/cortex/dist/workflows/selectors';
import THEME from '../theme';
import { getActivePauses } from './CasePauseStatus';
import { ArrowRight, ExternalLink } from './Icons';
import Pause from './Icons/Pause';
import Modal from './Modal';
import Workflow from './Workflows/Workflow';
import WorkflowStages from './WorkflowStages';
import { uniqueBy } from '@debbie/common/dist/util';
import { useCaseVouchersByCase } from '@debbie/cortex/dist/case-vouchers';
import { usePaymentPlansByCaseId } from '@debbie/cortex/dist/paymentPlans';
import { useDocumentsByReference } from '@debbie/cortex/dist/documents';
import { isAdmin } from '@debbie/common/dist/permissions';
import { useInteractionsByReference } from '@debbie/cortex/dist/interactions';
import { Entity } from '@debbie/common/dist';
const WorkflowStatus = (props) => {
    var _a, _b;
    const { case: singleCase, customer } = props;
    const lang = useSelector((s) => s.lang);
    const workflows = useSelector(selectWorkflows);
    const updateTypesMap = useSelector(selectUpdateTypesMap);
    const updateTypes = useSelector(selectUpdateTypes);
    const caseVouchers_ = useCaseVouchersByCase(singleCase.caseId);
    const caseVouchers = h.hasData(caseVouchers_) ? caseVouchers_.data : null;
    const meRole = useSelector(selectRole);
    const caseUpdates = useSelector((s) => singleCase && selectCaseUpdates(s, singleCase.caseId));
    const paymentPlansLoadable = usePaymentPlansByCaseId(singleCase === null || singleCase === void 0 ? void 0 : singleCase.caseId);
    const paymentPlans = h.hasData(paymentPlansLoadable)
        ? paymentPlansLoadable.data
        : null;
    const documentsLoadable = useDocumentsByReference(singleCase === null || singleCase === void 0 ? void 0 : singleCase.caseId);
    const documents = h.hasData(documentsLoadable) ? documentsLoadable.data : null;
    const interactionsLoader = useInteractionsByReference(Entity.Case, props.case.caseId);
    const interactions = h.hasData(interactionsLoader)
        ? interactionsLoader.data
        : null;
    const [modalOpen, setModalOpen] = useState(false);
    const hasFoundation = documents && !!documents.find((document) => isDocumentFoundation(document));
    const foundationTypes = documents
        ? uniqueBy(getFoundations(documents), (d) => d.type).map((d) => d.type)
        : [];
    const workflow = workflows &&
        props.case.workflowId &&
        workflows.find((workflow) => workflow.workflowId === props.case.workflowId);
    const nextTask = workflow &&
        caseUpdates &&
        caseUpdates &&
        props.case &&
        caseVouchers &&
        documents &&
        interactions &&
        typeof hasFoundation === 'boolean'
        ? getNextTask(caseUpdates, workflow, {
            contact: convertUserToContact(getContactPerson(customer)),
            isCompany: props.case.isCompany,
            updates: caseUpdates,
            caseVouchers: caseVouchers,
            caseGroupId: ((_a = props.case.caseGroup) === null || _a === void 0 ? void 0 : _a.id) || null,
            caseId: props.case.caseId,
            creditorId: props.case.creditorId,
            hasFoundation,
            foundationTypes,
            customerTags: customer.tags,
            interactions: interactions,
        })
        : null;
    const paymentPlan = getCurrentPaymentPlan(paymentPlans);
    const activePaymentPlan = (paymentPlan === null || paymentPlan === void 0 ? void 0 : paymentPlan.status) === PaymentPlanStatus.ACTIVE &&
        singleCase.status === CaseStatus.VERIFIED;
    const workflowPaused = (singleCase &&
        caseUpdates &&
        meRole &&
        getActivePauses(caseUpdates, updateTypesMap, meRole).some((activePause) => activePause.futurePause === null && activePause.updateType.pausing)) ||
        activePaymentPlan;
    const updateTypeId = nextTask &&
        (nextTask.type === NextTaskType.NormalTask ||
            nextTask.type === NextTaskType.StartingPointTask) &&
        ((_b = nextTask.task) === null || _b === void 0 ? void 0 : _b.updateTypeId);
    const updateType = updateTypeId && updateTypesMap[updateTypeId];
    if (!workflow)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(WorkflowTitle, { onClick: () => setModalOpen(!modalOpen) },
            React.createElement("div", null,
                React.createElement("h3", { style: { display: 'inline-block', verticalAlign: 'middle' } }, workflow && workflow.title),
                caseUpdates && workflow && singleCase && (React.createElement(WorkflowStages, { workflow: workflow, updates: caseUpdates, case: singleCase }))),
            singleCase &&
                (() => {
                    const nextTaskTitle = updateType &&
                        (lang.updateTypes[updateType.updateTypeId] || updateType.label);
                    const dueDate = nextTask &&
                        (nextTask.type === NextTaskType.NormalTask ||
                            nextTask.type === NextTaskType.StartingPointTask) &&
                        nextTask.date;
                    return (React.createElement("p", { "data-tooltip-content": workflowPaused
                            ? lang.cases.caseIsPaused
                            : activePaymentPlan
                                ? lang.paymentPlans.paymentPlan
                                : `${lang.cases.dueDateIsIn} ${dueDate
                                    ? moment
                                        .duration(moment(dueDate).diff(moment()))
                                        .asDays()
                                        .toFixed()
                                    : 0} ${lang.cases.days} (${dueDate
                                    ? moment(dueDate).format(THEME.DATE_FORMAT_LONG)
                                    : ''})`, "data-tooltip-id": "tooltip-default" }, activePaymentPlan ? (lang.paymentPlans.paymentPlan) : (React.createElement(React.Fragment, null, (nextTaskTitle ||
                        (nextTask === null || nextTask === void 0 ? void 0 : nextTask.type) === NextTaskType.ManualTask) && (React.createElement(React.Fragment, null,
                        workflowPaused && (React.createElement(Pause, { style: {
                                height: '1.8em',
                                width: '1.8em',
                                margin: '-0.1em 0.3em -0.5em 0em',
                            } })),
                        nextTask.pastUpdate ? (React.createElement(React.Fragment, null,
                            lang.updateTypes[nextTask.pastUpdate.updateTypeId] || nextTask.pastUpdate.label,
                            ' ',
                            React.createElement(ArrowRight, { style: {
                                    margin: '0.2em 0.5em -0.2em',
                                } }),
                            ' ')) : null,
                        (nextTask === null || nextTask === void 0 ? void 0 : nextTask.type) === NextTaskType.ManualTask
                            ? lang.workflows.manualSelection
                            : nextTaskTitle))))));
                })()),
        modalOpen && (React.createElement(Modal, { header: React.createElement(React.Fragment, null,
                workflow.title,
                ' ',
                meRole && isAdmin(meRole) && (React.createElement(ExternalLink, { style: {
                        float: 'inherit',
                        margin: '0.1em 0 -0.1em',
                        cursor: 'pointer',
                    }, onClick: () => c.redirect.redirect(`/workflows/${workflow.workflowId}`) }))), onToggle: () => setModalOpen(!modalOpen), maxWidth: "1600px" }, updateTypes &&
            singleCase &&
            caseUpdates &&
            caseVouchers &&
            customer &&
            interactions &&
            typeof hasFoundation === 'boolean' && (React.createElement(Workflow, { updateTypes: updateTypes, workflow: workflow, height: `calc(100vh - ${THEME.NAV_TOP_HEIGHT + 120}px)`, caseContext: {
                singleCase,
                updates: caseUpdates,
                caseVouchers: caseVouchers,
                customer,
                hasFoundation,
                foundationTypes,
                interactions,
            }, closeModal: () => setModalOpen(false) }))))));
};
export default WorkflowStatus;
const WorkflowTitle = styled.div `
  display: inline-block;
  font-size: 0.75em;
  font-weight: 900;
  cursor: pointer;

  h3 {
    margin: 0;
  }

  p {
    margin: 0.2em 0;
    font-size: 0.8em;
  }
`;
//# sourceMappingURL=WorkflowStatus.js.map